/**
 * The countries a job's search can look in: ISO 3166-1 alpha-2 codes, plus XK for Kosovo, which LinkedIn profiles
 * use. The same list as finlay-api's `JobCountries`, which refuses any other code. A region is several countries;
 * there is no list of regions.
 */
const COUNTRY_CODES = (
  'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY ' +
  'BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK ' +
  'FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR ' +
  'IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ' +
  'ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM ' +
  'PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF ' +
  'TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
).split(' ');

const codes = new Set(COUNTRY_CODES);

export const isCountryCode = (value: string): boolean => codes.has(value);

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

/** A country's English name, or its code when the browser doesn't know it. */
export const countryName = (code: string): string =>
  regionNames.of(code) ?? code;

/** Every country, by name; the multi-select also finds one by its code. */
export const countryOptions = COUNTRY_CODES.map((code) => ({
  value: code,
  label: countryName(code),
})).sort((a, b) => a.label.localeCompare(b.label, 'en'));
